import { CustomerPlan } from './request-settings-service-types'

export const getEnabledPlanIds = (plans?: CustomerPlan[] | null): number[] =>
  plans?.filter(plan => plan.enabled).map(plan => plan.id) ?? []
